import React from 'react';
import { bool, shape, string } from 'prop-types';

const CuttingFurrows = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 14V19L4 18L1 19V14L4 13L7 14Z" fill="currentColor" />
    <path d="M15 14V19L12 18L9 19V14L12 13L15 14Z" fill="currentColor" />
    <path d="M23 14V19L20 18L17 19V14L20 13L23 14Z" fill="currentColor" />
    <path d="M21 11.2998L20 11L19 11.2998V8H13V11.2998L12 11L11 11.2998V8H5V11.2998L4 11L3 11.2998V6H21V11.2998Z" fill="currentColor" />
  </svg>
);

CuttingFurrows.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default CuttingFurrows;
